/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CustomerDocsAccessDtov1 } from '../models/customer-docs-access-dtov-1';


/**
 * API for accessing SoftCo customer documentation from within SLM. Returns the doc hub callback URL carrying a short-lived hand-off token scoped to the caller's role.
 */
@Injectable({
  providedIn: 'root',
})
export class CustomerDocsV1Service extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getCustomerDocsAccessV1
   */
  static readonly GetCustomerDocsAccessV1Path = '/v1/customer-docs/access';

  /**
   * Get the doc hub link, with a short-lived access token, for the current user.
   *
   * Returns the doc hub callback URL the UI should open (side drawer or new tab). It carries a 60 second hand-off token; the hub verifies it and sets its own session cookie. Request a fresh link each time the docs are opened.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCustomerDocsAccessV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCustomerDocsAccessV1$Response(params?: {
    site?: string;
    rt?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<CustomerDocsAccessDtov1>> {

    const rb = new RequestBuilder(this.rootUrl, CustomerDocsV1Service.GetCustomerDocsAccessV1Path, 'get');
    if (params) {
      rb.query('site', params.site, {});
      rb.query('rt', params.rt, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CustomerDocsAccessDtov1>;
      })
    );
  }

  /**
   * Get the doc hub link, with a short-lived access token, for the current user.
   *
   * Returns the doc hub callback URL the UI should open (side drawer or new tab). It carries a 60 second hand-off token; the hub verifies it and sets its own session cookie. Request a fresh link each time the docs are opened.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCustomerDocsAccessV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCustomerDocsAccessV1(params?: {
    site?: string;
    rt?: string;
  },
  context?: HttpContext

): Observable<CustomerDocsAccessDtov1> {

    return this.getCustomerDocsAccessV1$Response(params,context).pipe(
      map((r: StrictHttpResponse<CustomerDocsAccessDtov1>) => r.body as CustomerDocsAccessDtov1)
    );
  }

}
